/** Suggest a Y-axis max that clips isolated deep spikes while keeping shallow minima visible. */
export function suggestChartYMax(data) {
  const values = data
    .map((d) => Math.abs(Number(d.depth)))
    .filter((d) => d > 0)
    .sort((a, b) => a - b);
  if (values.length === 0) {
    return 30;
  }
  const absoluteMax = values[values.length - 1];
  const p90 = values[Math.floor(values.length * 0.9)] ?? absoluteMax;
  if (absoluteMax > p90 * 1.2 && absoluteMax > p90 + 2) {
    return Math.ceil(p90 + 1);
  }
  return Math.ceil(absoluteMax);
}
